import React, { useState } from "react";
import { NAV_LINKS } from "../../data";

const SocialIcon = ({ href, children }) => (
  <a
    href={href || "#"}
    className="w-9 h-9 rounded-lg bg-white/7 border border-white/10 flex items-center justify-center cursor-pointer transition-all hover:bg-blue-600 hover:border-blue-600"
  >
    <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white/70">{children}</svg>
  </a>
);

const Footer = ({ navigate }) => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) { setSubscribed(true); setEmail(""); }
  };

  return (
    <footer className="bg-slate-950 text-white/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        {/* Main grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-14 border-b border-white/8">

          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <button onClick={() => navigate("home")} className="flex items-center gap-2.5 bg-transparent border-none cursor-pointer mb-4">
              <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-blue-500 flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-white">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                </svg>
              </span>
              <span className="font-head font-bold text-lg text-white">
                Eminent <span className="text-blue-400">Solutions</span>
              </span>
            </button>
            <p className="text-sm leading-relaxed text-white/45 mb-5">
              We develop intelligent AI-powered software solutions that transform operations and deliver measurable results.
            </p>
               <div className="flex gap-3">

      {/* Facebook */}
      <a
        href="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white hover:bg-blue-600 hover:scale-110 transition-all duration-300"
      >
        <SocialIcon>
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </SocialIcon>
      </a>

      {/* Instagram */}
      <a
        href="https://instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white hover:bg-pink-500 hover:scale-110 transition-all duration-300"
      >
        <SocialIcon>
          <path d="M7.5 2C4.42 2 2 4.42 2 7.5v9C2 19.58 4.42 22 7.5 22h9c3.08 0 5.5-2.42 5.5-5.5v-9C22 4.42 19.58 2 16.5 2h-9zm4.5 5.5A4.5 4.5 0 1111.999 16 4.5 4.5 0 0112 7.5zm0 7.4A2.9 2.9 0 1012 9.1a2.9 2.9 0 000 5.8zm4.8-8.8a1.1 1.1 0 11-1.1-1.1 1.1 1.1 0 011.1 1.1z" />
        </SocialIcon>
      </a>

      {/* LinkedIn */}
      <a
        href="https://www.linkedin.com/company/eminentsolutions-net/about/"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white hover:bg-blue-700 hover:scale-110 transition-all duration-300"
      >
        <SocialIcon>
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </SocialIcon>
      </a>

    </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-head font-bold text-sm text-white mb-4 uppercase tracking-wide">Products</h4>
            <ul className="space-y-2.5">
              {["SmartVision AI™", "ReplenishAI™", "RetailIQ™", "AuditApp™", "Custom Solutions"].map(p => (
                <li key={p}>
                  <button onClick={() => navigate("products")} className="text-sm text-white/45 bg-transparent border-none cursor-pointer hover:text-white transition-colors p-0 text-left">
                    {p}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-head font-bold text-sm text-white mb-4 uppercase tracking-wide">Company</h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map(l => (
                <li key={l.id}>
                  <button onClick={() => navigate(l.id)} className="text-sm text-white/45 bg-transparent border-none cursor-pointer hover:text-white transition-colors p-0 text-left">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-head font-bold text-sm text-white mb-4 uppercase tracking-wide">Stay Updated</h4>
            <p className="text-sm text-white/45 leading-relaxed mb-4">Get the latest in AI & software innovation. No spam, ever.</p>
            {subscribed ? (
              <div className="bg-emerald-500/15 border border-emerald-500/30 rounded-xl p-3 text-emerald-400 text-sm font-head font-semibold text-center">
                ✅ Subscribed! Thank you.
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 min-w-0 px-3 py-2.5 rounded-lg bg-white/6 border border-white/12 text-white text-sm placeholder-white/30 outline-none focus:border-blue-500 transition-colors font-body"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-lg bg-blue-600 text-white font-head font-semibold text-sm cursor-pointer border-none hover:bg-blue-500 transition-colors shrink-0"
                >
                  Go
                </button>
              </form>
            )}
            <div className="mt-5">
              <p className="text-xs font-head font-semibold text-white/30 uppercase tracking-widest mb-2">Contact</p>
              <p className="text-xs text-white/40">sales@eminentsolutions.net</p>
              <p className="text-xs text-white/40 mt-1">Plot #19-A, Korangi Road, Karachi</p>
            </div>
          </div>
        </div>

      
      </div>
    </footer>
  );
};

export default Footer;
